"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgLocationPinFilled = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.736 20.91a24.928 24.928 0 0 0 2.507-2.411C18.58 15.904 20 13.166 20 10.364 20 5.756 16.43 2 12 2s-8 3.756-8 8.364c0 2.801 1.42 5.54 3.757 8.135a24.923 24.923 0 0 0 3.337 3.075c.154.117.267.2.332.245a1 1 0 0 0 1.148 0 22.45 22.45 0 0 0 1.162-.909ZM15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgLocationPinFilled);
//# sourceMappingURL=SvgLocationPinFilled.js.map